// extracted by mini-css-extract-plugin
export default {"container":"Acasă_container__4AdRJ"};